import React, { useEffect, useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { Document, Page, pdfjs } from "react-pdf";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { b64toBlob } from "../../../app/util/base64toBlob";
import agent from "../../../app/api/agent";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface IProps {
  id: string;
}

const GraphicRepresentation: React.FC<IProps> = ({ id }) => {
  const [pdf, setPdf] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [numPages, setNumPages] = useState(1);

  useEffect(() => {
    const loadPDF = async () => {
      try {
        const data = await agent.Payroll.getBase64PDFById(id);
        setPdf(data);
      } catch (error) {
        console.error("Error loading PDF:", error);
        setPdf(null);
      } finally {
        setLoading(false);
      }
    };

    loadPDF();
  }, [id]);

  const downloadHandle = () => {
    if (pdf) {
      const blob = b64toBlob(pdf, "application/pdf");
      const blobUrl = URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = blobUrl;
      a.download = `payroll_${id}.pdf`;
      a.click();
    }
  };

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };

  if (loading) {
    return <LoadingComponent content="Cargando PDF..." />;
  }

  return (
    <div>
      <Button
        color="blue"
        onClick={downloadHandle}
        disabled={pdf === null}
      >
        <Icon name="download" />
        Descargar
      </Button>
      <br />
      <br />
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          overflowY: "auto",
          overflowX: "auto",
        }}
      >
        <Document
          loading="Cargando"
          error={
            <div className="noPdfDiv">
              <span>El documento no tiene un PDF asociado</span>
            </div>
          }
          onLoadSuccess={onDocumentLoadSuccess}
          file={`data:application/pdf;base64,${pdf}`}
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              scale={1.5}
              key={`page_${index + 1}`}
              pageNumber={index + 1}
            />
          ))}
        </Document>
      </div>
    </div>
  );
};

export default observer(GraphicRepresentation);
